import httpClient from '@common/api/httpClient';
import { type LegacyUserDetails, type LegacyUserResponse } from '@common/types/api';
import { type GUID } from '@common/types/brandedTypes';

export async function createLegacyUserAccess(
  userName: string,
  macAddress: string,
) {
  const { data } = await httpClient.post<LegacyUserResponse>('/rest/v1/LegacyUsers/UserAccesses', {
    userName,
    macAddress,
  });
  return data;
}

/**
 * @throws {ApiError} `invalid-input` when the server rejects the account, e.g. the email is
 * already in use.
 */
export async function createNewUserFromLegacyUser(
  userName: string,
  macAddress: string,
  email: string,
  password: string,
  firstName: string,
  lastName: string,
  confirmationUrl: string,
) {
  await httpClient.post('/rest/v1/LegacyUsers', {
    userName,
    macAddress,
    email,
    password,
    firstName,
    lastName,
    confirmationUrl,
  });
}

export async function verifyLegacyEmail(
  activationToken: string,
) {
  await httpClient.post('/rest/v1/LegacyUsers/verify', { activationToken });
}

export async function fetchLegacyUserByUserId(
  id: GUID,
) {
  try {
    const { data } = await httpClient.get<LegacyUserDetails>(`/rest/v1/LegacyUsers/User/${id}`);
    return data;
  } catch {
    return undefined;
  }
}
